import { Toggle } from '@/components/ui/toggle';
import { cn } from '@/lib/utils';

export const CHIPROW =
  'no-scrollbar flex gap-2 overflow-x-auto -mx-[var(--pad)] px-[var(--pad)] py-0.5 [&>button]:shrink-0';
export const CHIPROW_TALL = '[&>button]:px-4 [&>button]:py-2.75';

export function Chip({
  on,
  label,
  count,
  onClick,
  className,
}: {
  on: boolean;
  label: string;
  count?: number;
  onClick: () => void;
  className?: string;
}) {
  return (
    <Toggle
      pressed={on}
      onPressedChange={() => onClick()}
      className={cn(
        'border-border-strong text-muted-foreground text-t12h hover:border-primary h-auto min-h-11 flex-none gap-1.5 rounded-full border bg-transparent px-3.5 py-0 font-bold tracking-[-0.01em] whitespace-nowrap hover:bg-transparent',
        'data-[state=on]:border-primary data-[state=on]:bg-primary data-[state=on]:text-primary-foreground data-[state=on]:hover:bg-primary',
        className,
      )}
    >
      <span>{label}</span>
      {count !== undefined && (
        <span className="font-extrabold tabular-nums opacity-[0.62]">{count}</span>
      )}
    </Toggle>
  );
}
